/**
 请组合使用eg:
 <customizable-view config="customizedConfig">
    <query-form config="customizedConfig.queryConfig"></query-form>
    <table-label-filter config="customizedConfig.tableFieldConfig"></table-label-filter>
 </customizable-view>
 */

import angular from 'angular'

const customizableViewModule = angular.module('app.customizableView', [])

export default customizableViewModule.name

function modalCtrl($scope, configList, configField, $uibModalInstance) {
  $scope.$on('$stateChangeStart', (e, toState) => {
    if (toState.name.indexOf('login') != -1) {
      $scope.cancel()
    }
  })
  // 点击确定才生效 深克隆创建隔离作用域
  const isolatedConfigList = []
  if (configList.splitBillFlag) {
    // 票据拆分的选择框逻辑
    $scope.configSet = {}
    $scope.config = []
    for (let key in configList) {
      if (key === 'splitBillFlag') {
        $scope.configSet[key] = configList[key]
      } else {
        $scope.configSet[key] = []
        configList[key].forEach((config) => {
          $scope.configSet[key].push($.extend(true, {}, config))
        })
        $scope.config = $scope.config.concat($scope.configSet[key])
      }
    }
  } else {
    configList.forEach((config) => {
      isolatedConfigList.push($.extend(true, {}, config))
    })
    $scope.config = isolatedConfigList
  }

  // 关闭
  $scope.cancel = function cancel() {
    $uibModalInstance.dismiss('cancel')
  }
  // 确定
  $scope.ok = function ok() {
    if ($scope.configSet) {
      $scope.config = $scope.configSet
    }
    $uibModalInstance.close({
      config: $scope.config,
      configField,
    })
  }
  $scope.onSyllableSelect = function onSyllableSelect(config) {
    const len = config.length
    let flag = true
    for (let i = 0; i < len; i++) {
      // 没有禁用选项
      // if (config[i].default == false && config[i].selected == false) {
      //     flag = false
      // }
      if (config[i].selected === false) {
        flag = false
      }
    }
    $scope.allChoose(flag, 2)
  }

  $scope.allChoose = function allChoose(selected, status) {
    const len = $scope.config.length
    if (status == 1) {
      for (let i = 0; i < len; i++) {
        // 没有禁用选项
        // if ($scope.config[i].default == false) {
        //     $scope.config[i].selected = selected
        // }
        $scope.config[i].selected = selected
      }
    } else {
      $scope.selected = selected
    }
  }
  $scope.onSyllableSelect($scope.config)
}

function getDialogTemplate(label) {
  return `
        <div class="page-settablesyllable">
            <div class="modal-header clearfix">
                <h3 class="modal-title">${label}</h3>
                <div class="modal-cancel close" ng-click="cancel()"><i class="icon iconfont icon-shanchu3"></i></div>
            </div>
            <div class="modal-body form-horizontal clearfix">
                <div class="row" ng-if="!configSet">
                    <div ng-repeat="j in config" ng-show="j.label && !j.isHide" class="col-xs-4 modal-row modal-row-setsyllableModal">
                        <label class="u-selfcheckbox j-selfcheckbox clearfix" ng-class="{'z-crt': j.selected,'z-disabled': false}">
                            <input type="checkbox" ng-model="j.selected" ng-change="onSyllableSelect(config)" ng-disabled="false" />
                            <span class="iconfontbox">
                                <i class="icon iconfont icon-gou"></i>
                            </span>
                            <span class="text">{{ j.label}}</span>
                        </label>
                    </div>
                </div>
                <!-- 票据拆分的查询条件框 -->
                <div class="mod-body-split-bill-content" ng-if="configSet ">
                    <div class="clearfix">
                        <div class="export-sencod-title">通用查询条件</div>
                        <div ng-repeat="j in configSet.commonField" ng-show="j.label && !j.isHide" class="col-xs-4 modal-row modal-row-setsyllableModal">
                            <label class="u-selfcheckbox j-selfcheckbox clearfix"
                                ng-class="{'z-crt': j.selected,'z-disabled': false}">
                                <input type="checkbox" ng-model="j.selected" ng-change="onSyllableSelect(config)"
                                    ng-disabled="false" />
                                <span class="iconfontbox">
                                    <i class="icon iconfont icon-gou"></i>
                                </span>
                                <span class="text">{{ j.label}}</span>
                            </label>
                        </div>
                    </div>
                    <div class="clearfix">
                        <div class="export-sencod-title">增值税发票查询条件</div>
                        <div ng-repeat="j in configSet.valueAddedTaxField" ng-show="j.label && !j.isHide" class="col-xs-4 modal-row modal-row-setsyllableModal">
                            <label class="u-selfcheckbox j-selfcheckbox clearfix"
                                ng-class="{'z-crt': j.selected,'z-disabled': false}">
                                <input type="checkbox" ng-model="j.selected" ng-change="onSyllableSelect(config)"
                                    ng-disabled="false" />
                                <span class="iconfontbox">
                                    <i class="icon iconfont icon-gou"></i>
                                </span>
                                <span class="text">{{ j.label}}</span>
                            </label>
                        </div>
                    </div>
                    <div class="clearfix">
                        <div class="export-sencod-title">其他发票查询条件</div>
                        <div ng-repeat="j in configSet.otherInvoiceField" ng-show="j.label && !j.isHide" class="col-xs-4 modal-row modal-row-setsyllableModal">
                            <label class="u-selfcheckbox j-selfcheckbox clearfix"
                                ng-class="{'z-crt': j.selected,'z-disabled': false}">
                                <input type="checkbox" ng-model="j.selected" ng-change="onSyllableSelect(config)"
                                    ng-disabled="false" />
                                <span class="iconfontbox">
                                    <i class="icon iconfont icon-gou"></i>
                                </span>
                                <span class="text">{{ j.label}}</span>
                            </label>
                        </div>
                    </div>
                </div>               
            </div>
            <div class="modal-footer">
                <div class="col-xs-2 modal-row modal-row-setsyllableModal" >
                    <label class="u-selfcheckbox j-selfcheckbox clearfix" ng-class="{'z-crt': selected}" style="
                    padding-right:30px;margin-top:9px;">
                        <input type="checkbox" ng-model="selected" ng-change="allChoose(selected,1)"  />
                        <span class="iconfontbox">
                            <i class="icon iconfont icon-gou"></i>
                        </span>
                        <span class="text">全选</span>
                    </label>
                </div>
                <button class="btn btn-default btn-md" type="button" ng-click="cancel()">取消</button>
                <button class="btn btn-primary btn-md" type="button" ng-click="ok()">确定</button>
            </div>
        </div>
    `
}

/**
 * 从配置中获取表单和表格的配置字段名，如示例配置 返回
 * eg: <query-form config="customizedConfig.queryConfig"></query-form>
 * @param  {String} customizedConfig.queryConfig
 * @return {String} eg: 'queryConfig'
 */
function getFieldNameFromConfig(configAttr) {
  const fieldNameArr = configAttr.split('.')
  return fieldNameArr[fieldNameArr.length - 1]
}

function hasSearchCondition(configData, scope) {
  if (configData.splitBillFlag) {
    scope.noSearchCondition = true
    for (let [key, value] of Object.entries(configData)) {
      if (key !== 'splitBillFlag') {
        for (let item of value) {
          if (item.selected && !item.isHide) {
            scope.noSearchCondition = false
            break
          }
        }
        if (!scope.noSearchCondition) {
          break
        }
      }
    }
  } else {
    scope.noSearchCondition = true
    for (let item of configData) {
      if (item.selected && !item.isHide) {
        scope.noSearchCondition = false
        break
      }
    }
  }
}

customizableViewModule.directive('customizableView', [
  () => ({
    restrict: 'AE',
    transclude: true,
    replace: true,
    scope: {
      profileType: '<',
      config: '=',
      selected: '=',
      selectedChange: '=',
    },
    template: `
        <div class="ibox-content form-horizontal ibox" ng-transclude></div>
    `,
    controller: [
      '$scope',
      'httpRequest',
      '$uibModal',
      function ctrl($scope, httpRequest, $uibModal) {
        window.currentProfileType = $scope.profileType
        function loadSavedConfig(profileType) {
          if ((!profileType && profileType !== 0) || !$scope.config) {
            return
          }
          httpRequest.get_getUserCustomized(profileType).then((res) => {
            if (res.data.value) {
              const savedConfig = JSON.parse(res.data.value)
              if (
                savedConfig.queryConfig &&
                savedConfig.queryConfig.commonField
              ) {
                savedConfig.queryConfig.commonField.forEach((i) => {
                  $scope.config.queryConfig.commonField.forEach((o) => {
                    if (i.label == o.label) o.selected = i.selected
                  })
                })
                savedConfig.queryConfig.otherInvoiceField.forEach((i) => {
                  $scope.config.queryConfig.otherInvoiceField.forEach((o) => {
                    if (i.label == o.label) o.selected = i.selected
                  })
                })
                savedConfig.queryConfig.valueAddedTaxField.forEach((i) => {
                  $scope.config.queryConfig.valueAddedTaxField.forEach((o) => {
                    if (i.label == o.label) o.selected = i.selected
                  })
                })
              } else {
                savedConfig.queryConfig &&
                  savedConfig.queryConfig.forEach((i) => {
                    $scope.config.queryConfig.forEach((o) => {
                      if (i.label == o.label) o.selected = i.selected
                    })
                  })
              }
              savedConfig.queryForm &&
                savedConfig.queryForm.forEach((i) => {
                  $scope.config.queryForm.forEach((o) => {
                    if (i.label == o.label) o.selected = i.selected
                  })
                })
              savedConfig.invListLabel &&
                savedConfig.invListLabel.forEach((i) => {
                  $scope.config.invListLabel.forEach((o) => {
                    if (i.label == o.label) o.selected = i.selected
                  })
                })
              savedConfig.table &&
                savedConfig.table.forEach((i) => {
                  $scope.config.table.forEach((o) => {
                    if (i.label == o.label) o.selected = i.selected
                  })
                })
                $scope.selectedChange && $scope.selectedChange(savedConfig)
            }
          })
        }
        loadSavedConfig($scope.profileType)
        // 适配tab
        $scope.$watch('profileType', (newVal, oldValue) => {
          // if (oldValue === newVal) {
          //     return
          // }
          window.currentProfileType = $scope.profileType
          $scope.profileType = newVal
          loadSavedConfig($scope.profileType)
        })
        this.save = function save() {
          httpRequest.post_saveUserCustomized({
            profileInfo: JSON.stringify($scope.config),
            profileType: $scope.profileType,
          })
        }
        this.openDialog = function openDialog(title, config, configField) {
          $uibModal
            .open({
              template: getDialogTemplate(title),
              backdrop: 'static',
              controller: [
                '$scope',
                'config',
                'configField',
                '$uibModalInstance',
                modalCtrl,
              ],
              openedClass: 'mod-modal mod-modal-lg',
              resolve: {
                config() {
                  return config
                },
                configField() {
                  return configField
                },
              },
            })
            .result.then((data) => {
              // 点击确定才更新自定义配置
              $scope.config[data.configField] = data.config
              this.save()
              $scope.selectedChange && $scope.selectedChange($scope.config)
            })
        }
      },
    ],
  }),
])

customizableViewModule.directive('queryForm', [
  '$compile',
  '$timeout',
  ($compile, $timeout) => ({
    restrict: 'E',
    require: '?^^customizableView', // 一定要组合customizableView使用
    replace: true,
    transclude: true,
    template: `
    <form class="query-form clearfix" ng-submit="submit($event)" ng-transclude>
        
    </form>
    `,
    scope: {
      config: '<',
      advanced: '@',
      onSubmit: '&',
      pageNum: '=',
      onReset: '&',
      noReset: '@',
      noRefreshOrg: '@',
      onRefreshOrg: '&',
    },
    link(scope, element, attr, customizableView) {
      scope.submit = function submit(event) {
        event.preventDefault()
        // 查询重置为第一页
        scope.pageNum && (scope.pageNum = 1)
        $timeout(scope.onSubmit)
      }
      if (scope.config) {
        hasSearchCondition(scope.config, scope)
      }
      scope.$watch(
        'config',
        (newVal, oldValue) => {
          if (!newVal || newVal.length < 1 || oldValue === newVal) {
            return
          }
          hasSearchCondition(newVal, scope)
        },
        true
      )
      const btnLinckFn = $compile(`
        <div class="query-form-tips" ng-if="advanced && noSearchCondition">暂无搜索条件，请先去设置<a class="btn-link" ng-click="openDialog()">更多条件</a></div>
        <div ng-if="!advanced || !noSearchCondition" class="query-form-btns">
            <button type="submit" class="btn btn-search">搜索</button>
            <button ng-click="$event.preventDefault();onReset()" class="btn btn-default btn-lg btn-reset" ng-if="!noReset">重置</button>
            <a ng-if="advanced" class="btn btn-default query-more" ng-click="openDialog()"> 更多条件</a>
            <button ng-click="$event.preventDefault();onRefreshOrg()" class="btn btn-default btn-lg btn-reset" ng-if="noRefreshOrg">刷新机构</button>
        </div>`)
      btnLinckFn(scope).appendTo(element)
      scope.openDialog = function openDialog() {
        customizableView.openDialog(
          '自定义搜索条件',
          scope.config,
          getFieldNameFromConfig(attr.config)
        )
      }
    },
  }),
])
// deprecated 不要用
customizableViewModule.directive('tableLabel', [
  '$timeout',
  ($timeout) => ({
    restrict: 'E',
    require: '^^customizableView', // 一定要组合customizableView使用
    replace: true,
    transclude: true,
    template: `
    <div class="mod-table">
        <table class="table table-hover">
            <thead>
            <tr>
                <th class="table-col-checkbox" ng-if="isShowTableCheckbox">
                    <table-checkall ng-if="!checkAllKey" ref-list="resData" selected-type="object" ref-selected="selectedRows" ></table-checkall>
                    <table-checkall ng-if="checkAllKey" ref-list="resData" key="{{checkboxKey}}" ref-selected="selectedRows" ></table-checkall>
                </th>
                <th class="table-col-dropdown"></th>
                <th ng-repeat="t in tableData track by $index" ng-show="t.selected">
                    <span class="sort-wrapper" ng-click="clickHandle($event,$index)">
                        <span>{{t.label}}</span>
                        <span class="caret-wrapper"  ng-class="{'caret-active':$index==sortIndex}">
                            <i class="sort-caret ascending" ng-class="{'active-asc':orderMap.sortVal=='asc'}" sort="asc"></i>
                            <i class="sort-caret descending" ng-class="{'active-desc':orderMap.sortVal=='desc'}" sort="desc"></i>
                        </span>
                    </span>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr ng-mouseenter="item.dropdownDivShow=true"
                ng-mouseleave="item.dropdownDivShow=false" 
                ng-repeat="item in resData" ng-class="{true: 'tb-selected', false: ''}[item.selected]">
                <td ng-show="isShowTableCheckbox" style="line-height:12px;">
                <table-checkbox key="{{checkboxKey}}" selected-type="object" ref-selected="selectedRows" ref-row-data="item"></table-checkbox>
                </td>
                <td ng-show="isShowTableCheckbox" class="dropdown-box" ng-mouseenter="item.dropdownShow = true" ng-mouseleave="item.dropdownShow = false">
                    <table-dropdown ng-style="myObj"  config="tableDropdownConfig" table-cell="item"></table-dropdown>
                </td>
                <td ng-show="!isShowTableCheckbox" class="dropdown-box" ng-mouseenter="item.dropdownShow = true" ng-mouseleave="item.dropdownShow = false">
                    <table-dropdown style="padding-left: 16px;" ng-style="myObj"  config="tableDropdownConfig" table-cell="item" id="manageTabDrop"></table-dropdown>
                </td>
                <td ng-repeat="t in tableData" ng-show="t.selected">
                    <span ng-repeat="text in t.labelContent" ng-if="text.labelWord != 'adValoremTotal' && text.labelWord != 'totalAmt' && text.labelWord != 'totalTaxamt'">{{item[text.labelWord] | dictFilter : dictData[text.dictFilter] }}<br></span>
                    <span ng-if="t.labelContent[0].labelWord == 'adValoremTotal'">{{item.adValoremTotal | number : 2}}</span>   
                    <span ng-if="t.labelContent[0].labelWord == 'totalAmt'">{{item.totalAmt | number : 2}}</span><br ng-if="t.labelContent[1].labelWord == 'totalTaxamt'"> 
                    <span ng-if="t.labelContent[0].labelWord == 'totalTaxamt'">{{item.totalTaxamt | number : 2}}</span>   
                </td>
                </tr>
            </tbody>
            <nores-page res-data="resData" show-while="{showWhile:false}"></nores-page>
        </table>
        <div class="mod-pagination"  ng-show="resData.length">
            <div class=" text-right">
                <ul et-pagination previous-text="&lt;" next-text="&gt;" total-items="totalItems"
                    items-per-page="maxSize" ng-model="currentPage" max-size="10" force-ellipses="true"
                    rotate="true" ng-change="pageChange()" profile-type="profileType"></ul>
            </div>
            <!-- 
            <div class="m-totleinfo">共有{{totalItems}}条</div>
            <ul uib-pagination previous-text="&lt;" next-text="&gt;" items-per-page="maxSize"
                total-items="totalItems" ng-model="currentPage" ng-change="pageChanged()" max-size='10'
                force-ellipses='true' rotate='true'></ul>
            <div class="m-perpageselect">
                <select class="form-control" ng-model="maxSize" ng-options="m.id as m.text for m in perpageList" ng-selected="m.id == maxSize" ng-change="pageSelChange()">
                <input type="text" class="form-control" ng-model="pageModel">
                <span class="go" ng-click="pageModelChange()">跳至</span>
            </div>
            -->
        </div>
    </div>
    `,
    scope: {
      tableData: '=', // 表格展示字段
      resData: '=', // 表格数据
      filter: '<', // 是否出现字段过滤
      dictData: '<', // 字典对象
      maxSize: '=', // 每页最大值
      totalItems: '=', // 分页总计数
      currentPage: '=', // 分页当前页数
      pageChange: '&', // 分页页数改变回调
      isShowTableCheckbox: '<', // 是否显示多选框
      tableDropdownConfig: '<', // 是否显示多选框
      checkboxKey: '@', // 表格内容多选框选取时传特定字符串值，否则为对象
      checkAllKey: '@', // 表格全选框选取时传特定字符串值，否则为对象
      selectedRows: '=', // 多选框选取时传特定字符串值，否则为对象
      orderMap: '=', // 表头排序对象
      sortName: '@', // 排序字段名
      sortHandle: '&', // 排序回调
      sortIndexStorageName: '@',
      sortIndex: '@',
      profileType: '<',
    },
    link(scope) {
      // console.error('tableLabel is deprecated')
      // 添加分页总页数，最大页数选择，跳转 @author sjj

      // scope.sortIndex = '' //当前排序选中项
      if (!scope.sortIndex) {
        scope.sortIndex = ''
      }
      // scope.perpageList = [{
      //     text: '10条',
      //     id: 10
      // }, {
      //     text: '20条',
      //     id: 20
      // }, {
      //     text: '30条',
      //     id: 30
      // }, {
      //     text: '50条',
      //     id: 50
      // }]
      // 规范要求不设置初始值
      // scope.pageModel = scope.currentPage
      // scope.pageSelChange = function () {
      //     setTimeout(function () {
      //         scope.pageModel = scope.currentPage
      //         scope.pageChange()
      //     })
      // }
      // scope.pageModelChange = function () {
      //     console.log(scope.pageModel)
      //     if (scope.pageModel === scope.currentPage || !scope.pageModel) {
      //         return
      //     }
      //     scope.currentPage = Number(scope.pageModel)
      //     setTimeout(function () {
      //         scope.pageChange()
      //     })
      // }
      // scope.pageChanged = function () {
      //     $timeout(() => { // 分页插件会优先执行查询方法而导致没有完成页码双向绑定
      //         scope.pageChange()
      //     })
      // }
      scope.clickHandle = function (e, index) {
        scope.sortIndex = index
        if (scope.sortIndexStorageName) {
          sessionStorage.setItem(scope.sortIndexStorageName, index)
        }
        const currentKey =
          scope.tableData[index] &&
          scope.tableData[index].labelContent[0].labelWord
        if (scope.orderMap.sortKey != currentKey) {
          scope.orderMap.sortVal = ''
          scope.orderMap.sortKey = currentKey
        }
        if (e.target.nodeName == 'I') {
          if (scope.orderMap.sortVal == e.target.getAttribute('sort')) {
            scope.orderMap.sortVal = ''
            scope.orderMap.sortKey = ''
          } else {
            scope.orderMap.sortVal = e.target.getAttribute('sort')
          }
        } else if (scope.orderMap.sortVal === 'asc') {
          scope.orderMap.sortVal = 'desc'
        } else if (scope.orderMap.sortVal === 'desc') {
          scope.orderMap.sortVal = ''
          scope.orderMap.sortKey = ''
        } else {
          scope.orderMap.sortVal = 'asc'
        }
        scope.sortHandle && scope.sortHandle()
      }
    },
  }),
])

customizableViewModule.directive('tableLabelFilter', () => ({
  restrict: 'E',
  replace: true,
  require: '^customizableView', // 一定要组合customizableView使用
  template: `
       <a class="color-mainc pull-right u-btn-filtertable" ng-click="syllableModal()">字段筛选</a>
    `,
  scope: {
    config: '=',
  },
  link(scope, element, attr, customizableView) {
    scope.selected = false
    scope.syllableModal = function syllableModal() {
      customizableView.openDialog(
        '列表字段设置',
        scope.config,
        getFieldNameFromConfig(attr.config)
      )
    }
  },
}))
customizableViewModule.directive('queryFormToggle', () => ({
  template: `
        <button type="button" class="btn btn-query-toggle" ng-class="{'expanded': toggle}"  ng-click="triggerToggle()">
        查询
        <i class="iconfont" ng-class="{true :'icon-zhankaijiantoucopy7', false :'icon-zhankaijiantoucopy9'}[toggle]"></i>
        </button>
    `,
  restrict: 'E',
  replace: true,
  scope: {
    toggle: '=',
    refFormId: '@',
  },
  link(scope) {
    scope.toggle = Boolean(scope.toggle)
    scope.triggerToggle = function triggerToggle() {
      scope.toggle = !scope.toggle
    }
  },
}))

// 切换金税盘下拉框
customizableViewModule.directive('queryTaxSelect', () => ({
  template: `
    <div class="form-group">
        <span for="">{{title}}</span>
        <select class="form-control"
        ng-model="diskId"
        ng-change="taxDiskChange(diskId)">
        <option ng-repeat="op in options track by $index"
            value="{{op.diskId}}">{{op.diskName}}</option>
        </select>
    </div>
    `,
  restrict: 'E',
  replace: true,
  scope: {
    title: '<',
    options: '=',
    diskId: '=',
    taxDiskChange: '&',
  },
  link(scope) {
    // scope.taxDiskChanged = () => {
    //     scope.taxDiskChange(scope.diskId)
    // }
  },
}))



// WEBPACK FOOTER //
// ./src/components/customizableView/index.js